import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activePromoCode: false,
  currentErrorCode: '',
  currentErrorMessage: '',
  cyoType: 'cyo-package' as CyoType,
  maximumPerformances: 0,
  minimumPerformances: 0,
  packageLineNo: 0,
  promoCode: '',
  seats: 0,
  specialRequests: '',
  showCalendar: false,
  successMessages: '',
  upsellMessages: '',
};

const sessionVarsSlice = createSlice({
  name: 'sessionVars',
  initialState,
  reducers: {
    resetPackageVars(state) {
      return {
        ...initialState,
        cyoType: state.cyoType,
      };
    },
    setCalendarView(state, action) {
      return {
        ...state,
        showCalendar: action.payload,
      };
    },
    setCyoType(state, action) {
      return {
        ...state,
        cyoType: action.payload,
      };
    },
    setError(state, action) {
      return {
        ...state,
        currentErrorCode: action.payload.code,
        currentErrorMessage: action.payload.message,
      };
    },
    updatePackageVars(state, action) {
      const {
        activePromoCode,
        maximumPerformances,
        minimumPerformances,
        packageLineNo,
        successMessages,
        upsellMessages,
      } = action.payload;

      return {
        ...state,
        activePromoCode,
        maximumPerformances,
        minimumPerformances,
        packageLineNo,
        successMessages,
        upsellMessages,
      };
    },
    updatePromoCode(state, action) {
      return {
        ...state,
        promoCode: action.payload,
      };
    },
    updateSuccessMessages(state, action) {
      return {
        ...state,
        successMessages: action.payload,
      };
    },
    updateSeats(state, action) {
      return {
        ...state,
        seats: action.payload,
      };
    },
    updateSpecialRequests(state, action) {
      return {
        ...state,
        specialRequests: action.payload,
      };
    },
  },
});

const { actions, reducer: sessionSliceReducer } = sessionVarsSlice;

export const {
  resetPackageVars,
  setCalendarView,
  setCyoType,
  setError,
  updatePackageVars,
  updatePromoCode,
  updateSeats,
  updateSpecialRequests,
  updateSuccessMessages,
} = actions;

export default sessionSliceReducer;
